export default { 
  // Dashboard: require('./Dashboard').default,
  Epot: require('./epot').default,
  Certif: require('./certificate').default,
  Account: require('./account').default,
  Guide: require('./guide').default,
}